import styled from "styled-components";
import { COLORS } from "../../../const/colors";

export const AboutSection = styled.section`
  padding: 6rem 0 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      ${COLORS.WHITE} 0%,
      ${COLORS.BLACK} 70%
    );
    top: -150px;
    right: -150px;
    z-index: -1;
  }

  &::after {
    content: "";
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      ${COLORS.WHITE} 0%,
      ${COLORS.BLACK} 70%
    );
    bottom: -100px;
    left: -100px;
    z-index: -1;
  }
`;

export const AboutContainer = styled.div`
  max-width: 968px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;

  @media screen and (min-width: 992px) {
    padding: 0;
  }
`;

export const AboutImg = styled.img`
  width: 220px;
  border-radius: 1.5rem;
  justify-self: center;

  @media screen and (min-width: 992px) {
    width: 350px;
  }
`;

export const AboutData = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AboutInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media screen and (min-width: 576px) {
    grid-template-columns: repeat(4, 140px);
    justify-content: center;
  }

  @media screen and (min-width: 992px) {
    gap: 2rem;
  }
`;

export const AboutBox = styled.div`
  background-color: ${(props) =>
    props.light ? COLORS.DARK_BLUE : COLORS.WHITE};
  border-radius: 0.75rem;
  padding: 1rem 1.25rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 0.75rem;
    padding: 2px;
    background: linear-gradient(90deg, ${COLORS.WHITE}, ${COLORS.BLACK});
    background-size: 300% 100%;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  @keyframes aboutBorderAnimation {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 300% 0%;
    }
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

    &::before {
      animation: aboutBorderAnimation 4s linear infinite;
    }
  }

  @media screen and (max-width: 576px) {
    padding: 0.75rem 1rem;
  }
`;

export const AboutIcon = styled.div`
  font-size: 1.5rem;
  color: ${COLORS.ORANGE};
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    background: linear-gradient(45deg, ${COLORS.ORANGE}, ${COLORS.DARK_BLUE});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const AboutTitle = styled.h3`
  font-size: 0.875rem;
  color: ${(props) => (props.light ? COLORS.WHITE : COLORS.BLACK)};
  font-weight: 500;
  margin-bottom: 0.5rem;
`;

export const AboutSubTitle = styled.span`
  font-size: 0.74rem;
  color: ${(props) => (props.light ? COLORS.LIGHT_GRAY : COLORS.DARK_BLUE)};
  font-weight: 500;
`;

export const AboutDesc = styled.p`
  max-width: 700px;
  margin: 0 auto 2.5rem;
  color: ${(props) => (props.light ? COLORS.LIGHT_GRAY : COLORS.BLACK)};
  line-height: 1.8;
  font-size: 1rem;
  text-align: center;
  padding: 0 1rem;

  @media screen and (min-width: 768px) {
    text-align: center;
    font-size: 1.05rem;
  }
`;

export const Hire = styled.div`
  display: flex;
  justify-content: center;

  a {
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      width: calc(100% + 4px);
      height: calc(100% + 4px);
      background: linear-gradient(
        45deg,
        ${COLORS.WHITE},
        ${COLORS.BLACK},
        ${COLORS.WHITE},
        ${COLORS.BLACK}
      );
      background-size: 400%;
      z-index: -1;
      border-radius: 0.75rem;
      animation: animate-border 3s linear infinite;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover::before {
      opacity: 1;
    }

    @keyframes animate-border {
      0% {
        background-position: 0 0;
      }
      100% {
        background-position: 100% 100%;
      }
    }
  }
`;
